import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { useResponsive } from 'utils';
import config from 'config';

import { Button, Card, Spinner, Typography } from '../../../alf-design';
import ClaimDetailsHeader from './ClaimDetailsHeader';
import WithoutClaims from './WithoutClaims';
import ClaimDetails from './ClaimDetails';
import './Claims.css';

const Claims = ({ claims, loading, error }) => {
  const { screenIsDown } = useResponsive();
  const sortClaims = (a, b) => {
    if (a.claimStatus === 'Open' && b.claimStatus !== 'Open') {
      return -1;
    }
    if (a.claimStatus !== 'Open' && b.claimStatus === 'Open') {
      return 1;
    }

    if (a.claimStatus === 'Closed' && b.claimStatus === 'Closed') {
      const aClaimFiledDate = moment(a.claimFiledDate);
      const bClaimFiledDate = moment(b.claimFiledDate);

      if (aClaimFiledDate.isAfter(bClaimFiledDate)) {
        return -1;
      }
      if (aClaimFiledDate.isBefore(bClaimFiledDate)) {
        return 1;
      }
    }
    return 0;
  };

  if (loading) {
    return (
      <Card>
        <div className="circularProgress">
          {loading && <Spinner id="dashboard-spinner" size={80} />}
        </div>
      </Card>
    );
  }

  return (
    <>
      <div>
        {claims?.length === 0 || !claims ? (
          <WithoutClaims error={error} />
        ) : (
          <Card>
            <div className="flex justify-between items-center mb-[18px]">
              <Typography type="h2" component="h2">
                Claim Tracker
              </Typography>
              <Button
                id="Report-Loss-button"
                data-dd-action-name="dashboard.claims.file_claim"
                type="primary"
                onClick={() => window.open(config.fnol)}
                className="report-loss-button"
                link
              >
                File Claim
              </Button>
            </div>
            {screenIsDown('lg') ? (
              <>
                {claims.map((claim, index) => (
                  <div
                    key={claim.claimNumber}
                    header={<ClaimDetailsHeader index={index} claim={claim} />}
                  >
                    <ClaimDetails
                      index={index}
                      key={claim.claimNumber}
                      claim={claim}
                      lastClaim={index === claims.length - 1}
                    />
                  </div>
                ))}
              </>
            ) : (
              <>
                {claims.sort(sortClaims).map((claim, index) => (
                  <div
                    key={claim.claimNumber}
                    header={<ClaimDetailsHeader claim={claim} />}
                  >
                    <ClaimDetails
                      index={index}
                      key={claim.claimNumber}
                      claim={claim}
                      lastClaim={index === claims.length - 1}
                    />
                  </div>
                ))}
              </>
            )}
          </Card>
        )}
      </div>
    </>
  );
};

Claims.propTypes = {
  claims: PropTypes.arrayOf(PropTypes.shape({})),
  loading: PropTypes.bool,
};
export default Claims;
